import { useEffect, useState } from "react";
import api from "../../api/axios";

import {
  getRendezVous,
  createRendezVous,
  updateRendezVous,
  deleteRendezVous,
  updateEtatRendezVous,
  updateHeursRendezVous
} from "../../api/rendezVousService.api";

import { getClients } from "../../api/clients.api";
import { getEntretiens } from "../../api/typesEntretien.api";

import RendezVousForm from "../../components/RendezVous/RendezVousForm";
import RendezVousTable from "../../components/RendezVous/RendezVousTable";

import "../../components/RendezVous/RendezVous.css";


const RendezVousPage = () => {

  const [rendezVous, setRendezVous] = useState([]);
  const [clients, setClients] = useState([]);
  const [entretiens, setEntretiens] = useState([]);
  const [techniciens, setTechniciens] = useState([]);

  const [editData, setEditData] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  // =========================
  // FILTRES
  // =========================

  const [filterClient, setFilterClient] = useState("");
  const [clientSearch, setClientSearch] = useState("");

  const [filterMonth, setFilterMonth] = useState("");
  const [filterEtat, setFilterEtat] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 20;


  // =========================
  // CHARGEMENT DES DONNÉES
  // =========================

  const loadData = async () => {

    try {

      const rv = await getRendezVous();
      const cl = await getClients();
      const entretien = await getEntretiens();
      const tech = await api.get("/technicien");


      // TRI :
      // plus récent vers plus ancien

      const sortedRdv = [...rv.data].sort((a, b) => {

        const dateA = new Date(
          `${a.date_rdv}T${a.heure_debut || "00:00:00"}`
        );

        const dateB = new Date(
          `${b.date_rdv}T${b.heure_debut || "00:00:00"}`
        );

        return dateB - dateA;

      });


      setRendezVous(sortedRdv);
      setClients(cl.data);
      setEntretiens(entretien.data);
      setTechniciens(tech.data);


    } catch (error) {

      console.error(
        "Erreur chargement rendez-vous",
        error
      );

    }

  };


  useEffect(() => {

    loadData();

  }, []);


  // =========================
  // RESET PAGINATION
  // =========================

  useEffect(() => {

    setCurrentPage(1);

  }, [
    filterClient,
    filterMonth,
    filterEtat,
    clientSearch
  ]);


  // =========================
  // CLIENT CRÉÉ
  // =========================

  const handleClientCreated = (client) => {

    setClients(prev => [
      ...prev,
      client
    ]);

  };


  // =========================
  // OUVRIR AJOUT
  // =========================

  const handleOpenAdd = () => {

    setEditData(null);
    setFormOpen(true);

  };


  // =========================
  // OUVRIR MODIFICATION
  // =========================

  const handleOpenEdit = (rdv) => {

    setEditData(rdv);
    setFormOpen(true);

  };


  // =========================
  // CRÉATION
  // =========================

  const handleCreate = async (data) => {

    try {

      await createRendezVous(data);

      setFormOpen(false);

      await loadData();

    } catch (error) {

      console.error(
        "Erreur création rendez-vous",
        error
      );

    }

  };


  // =========================
  // MODIFICATION
  // =========================

  const handleUpdate = async (data) => {

    try {

      await updateRendezVous(
        editData.id,
        data
      );

      setEditData(null);
      setFormOpen(false);

      await loadData();

    } catch (error) {

      console.error(
        "Erreur modification rendez-vous",
        error
      );

    }

  };


  // =========================
  // SUPPRESSION
  // =========================

  const handleDelete = async (id) => {

    if (
      window.confirm(
        "Supprimer ce rendez-vous ?"
      )
    ) {

      try {

        await deleteRendezVous(id);

        await loadData();

      } catch (error) {

        console.error(
          "Erreur suppression rendez-vous",
          error
        );

      }

    }

  };


  // =========================
  // RECHERCHE CLIENT
  // =========================

  const clientsFiltres = clients.filter((client) => {

    const nom = client.nom || "";

    return nom
      .toLowerCase()
      .includes(
        clientSearch.toLowerCase()
      );

  });


  // =========================
  // SÉLECTION CLIENT
  // =========================

  const handleSelectClient = (client) => {

    setFilterClient(
      String(client.id)
    );

    setClientSearch(
      client.nom
    );

  };


  // =========================
  // EFFACER CLIENT
  // =========================

  const handleClearClient = () => {

    setFilterClient("");
    setClientSearch("");

  };


  // =========================
  // FILTRAGE
  // =========================

  const filteredRdv = rendezVous.filter((rdv) => {

    const matchClient =

      filterClient

        ? Number(rdv.client_id) ===
          Number(filterClient)

        : true;


    const matchMonth =

      filterMonth

        ? rdv.date_rdv?.slice(0, 7) ===
          filterMonth

        : true;


    const matchEtat =

      filterEtat

        ? rdv.etat_travaux ===
          filterEtat

        : true;


    return (

      matchClient &&
      matchMonth &&
      matchEtat

    );

  });


  // =========================
  // PAGINATION
  // =========================

  const totalPages = Math.ceil(
    filteredRdv.length /
    itemsPerPage
  );


  const paginatedRdv = filteredRdv.slice(

    (currentPage - 1) *
    itemsPerPage,

    currentPage *
    itemsPerPage

  );


  const goToPage = (page) => {

    if (
      page >= 1 &&
      page <= totalPages
    ) {

      setCurrentPage(page);

    }

  };


  // =========================
  // CHANGEMENT ÉTAT
  // =========================

  const handleChangeEtat = async (
    id,
    newEtat
  ) => {

    try {

      await updateEtatRendezVous(
        id,
        {
          etat_travaux: newEtat
        }
      );

      await loadData();

    } catch (error) {

      console.error(
        "Erreur changement état",
        error
      );

    }

  };


  // =========================
  // MODIFICATION HEURE FIN
  // =========================

  const onEditHeureFin = async (
    id,
    nouvelleHeure
  ) => {

    try {

      await updateHeursRendezVous(
        id,
        {
          heure_fin: nouvelleHeure
        }
      );


      setRendezVous(prev =>

        prev.map(rv =>

          rv.id === Number(id)

            ? {
                ...rv,
                heure_fin: nouvelleHeure
              }

            : rv

        )

      );


    } catch (error) {

      console.error(
        "Erreur modification heure fin",
        error
      );

      alert(
        "Impossible de modifier l'heure de fin"
      );

    }

  };


  // =========================
  // RENDU
  // =========================

  return (

    <div className="rendezvous-page">

      <h2>
        Gestion des rendez-vous !
      </h2>


      {/* =========================
          BOUTON AJOUT
      ========================== */}

      <button
        onClick={handleOpenAdd}
        className="btn-add"
      >
        Ajouter un rendez-vous
      </button>


      {/* =========================
          FORMULAIRE
      ========================== */}

      <div
        className={
          `form-container ${
            formOpen
              ? "open"
              : ""
          }`
        }
      >

        {formOpen && (

          <RendezVousForm

            onSubmit={
              editData
                ? handleUpdate
                : handleCreate
            }

            initialData={editData}

            techniciens={techniciens}

            clients={clients}

            entretiens={entretiens}

            onClientCreated={
              handleClientCreated
            }

          />

        )}


        {formOpen && (

          <button
            onClick={() => {

              setFormOpen(false);
              setEditData(null);

            }}

            className="btn-close"
          >
            Fermer
          </button>

        )}

      </div>


      {/* =========================
          FILTRES
      ========================== */}

      <div className="filters">


        {/* =====================
            RECHERCHE CLIENT
        ====================== */}

        <div className="client-filter">

          <div className="client-search-wrapper">

            <input
              type="text"
              placeholder="🔍 Rechercher un client..."
              value={clientSearch}

              onChange={(e) => {

                const value =
                  e.target.value;

                setClientSearch(value);

                // Si l'utilisateur modifie
                // la recherche, on enlève
                // l'ancien client sélectionné

                setFilterClient("");

              }}

              onFocus={() => {

                // Permet d'afficher
                // les résultats

              }}

              className="client-search-input"
            />


            {clientSearch && (

              <button
                type="button"
                className="clear-client"
                onClick={
                  handleClearClient
                }
              >
                ✕
              </button>

            )}

          </div>


          {/* =====================
              RÉSULTATS CLIENT
          ====================== */}

          {clientSearch &&
           !filterClient && (

            <div className="client-results">

              {clientsFiltres.length > 0 ? (

                clientsFiltres
                  .slice(0, 20)
                  .map((client) => (

                    <div
                      key={client.id}
                      className="client-result"

                      onClick={() =>
                        handleSelectClient(
                          client
                        )
                      }
                    >

                      {client.nom}

                    </div>

                  ))

              ) : (

                <div className="client-no-result">

                  Aucun client trouvé

                </div>

              )}

            </div>

          )}

        </div>


        {/* =====================
            FILTRE ÉTAT
        ====================== */}

        <select

          value={filterEtat}

          onChange={(e) =>
            setFilterEtat(
              e.target.value
            )
          }

        >

          <option value="">
            Tous les états
          </option>

          <option value="EN_ATTENTE">
            En attente
          </option>

          <option value="EN_COURS">
            En cours
          </option>

          <option value="TERMINE">
            Terminé
          </option>

        </select>


        {/* =====================
            FILTRE MOIS
        ====================== */}

        <input
          type="month"
          value={filterMonth}

          onChange={(e) =>
            setFilterMonth(
              e.target.value
            )
          }
        />


        {/* =====================
            RÉINITIALISER FILTRES
        ====================== */}

        {(filterClient ||
          filterMonth ||
          filterEtat) && (

          <button
            type="button"
            className="btn-reset-filters"

            onClick={() => {

              setFilterClient("");
              setClientSearch("");
              setFilterMonth("");
              setFilterEtat("");
              setCurrentPage(1);

            }}
          >
            Réinitialiser
          </button>

        )}

      </div>


      {/* =========================
          INFORMATIONS FILTRE
      ========================== */}

      <div className="filter-info">

        <strong>
          {filteredRdv.length}
        </strong>

        {" "}rendez-vous trouvé
        {filteredRdv.length > 1
          ? "s"
          : ""}

        {filterClient && (
          <>
            {" pour "}
            <strong>
              {clientSearch}
            </strong>
          </>
        )}

      </div>


      {/* =========================
          TABLEAU
      ========================== */}

      <RendezVousTable

        data={paginatedRdv}

        onEdit={handleOpenEdit}

        onDelete={handleDelete}

        entretiens={entretiens}

        clients={clients}

        techniciens={techniciens}

        onChangeEtat={
          handleChangeEtat
        }

        onEditHeureFin={
          onEditHeureFin
        }

      />


      {/* =========================
          PAGINATION
      ========================== */}

      {totalPages > 1 && (

        <div className="pagination">

          <button
            onClick={() =>
              goToPage(
                currentPage - 1
              )
            }

            disabled={
              currentPage === 1
            }
          >
            Précédent
          </button>


          {Array.from(
            {
              length: totalPages
            },
            (_, i) => (

              <button

                key={i + 1}

                className={
                  currentPage === i + 1
                    ? "active"
                    : ""
                }

                onClick={() =>
                  goToPage(
                    i + 1
                  )
                }

              >

                {i + 1}

              </button>

            )
          )}


          <button

            onClick={() =>
              goToPage(
                currentPage + 1
              )
            }

            disabled={
              currentPage ===
              totalPages
            }

          >
            Suivant
          </button>

        </div>

      )}

    </div>

  );

};


export default RendezVousPage;